module.exports = __webpack_public_path__ + "plus/img/053b2cc9ad87e9407f2a46704bf7e70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/solplanet-logo.png
// module id = Kfq4
// module chunks = 5